export const initCopyToClipboard = () => {
  const notification = document.querySelector("[data-copy-notification]");
  if (!notification) return;

  const showNotification = (message, type = "success") => {
    notification.textContent = message;
    notification.className = `notification notification--${type}`;
    notification.classList.add("active");

    clearTimeout(notification._timeout);
    notification._timeout = setTimeout(() => {
      notification.classList.remove("active");
    }, 2500);
  };

  document.addEventListener("click", async (e) => {
    const trigger = e.target.closest("[data-copy]");
    if (!trigger) return;

    e.preventDefault();

    const value = trigger.dataset.copyValue || window.location.href;

    const message = trigger.dataset.copyText || "Skopiowano do schowka";

    const type = trigger.dataset.copyType || "success";

    try {
      await navigator.clipboard.writeText(value); 
      showNotification(message, type);
    } catch (err) {
      showNotification("Nie udało się skopiować", "error");
      console.error(err);
    }
  });
};
